import { ReactComponent as YUJULogo } from "@/assets/icon/YUJU/icon-yuju.svg";

import IconBox from "../IconBox";

export const IconYUJULogo = (props) => <IconBox component={YUJULogo} {...props} />;
